import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2c4b58fb&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=2c4b58fb&prod&lang=less&scoped=true&"
import style1 from "./edit.vue?vue&type=style&index=1&id=2c4b58fb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b58fb",
  null
  
)

export default component.exports